import type { Contact, ContactRole } from 'bundles/backoffice/contacts/types';

export function findEmployerRole(employer: Contact, role: string, contactRoles: ContactRole[]) {
  if (!employer) {
    return null;
  }

  return contactRoles.find((possibleRole) => {
    const { contact } = possibleRole;

    if (!contact || possibleRole.role !== role || possibleRole._destroy) {
      return false;
    }

    if (employer.id) {
      return contact.id === employer.id;
    } else if (employer.crmContactId && employer.crmContactType) {
      return contact.crmContactId === employer.crmContactId && contact.crmContactType === employer.crmContactType;
    }

    return null;
  });
}
